import React from 'react';
import '../Styles/App.scss';
import Routes from "./Routes";


class App extends React.Component {
    
  render() {
    return ( 
        <Routes />
      );
    }
  }
  
  export default App;
